module.exports = __webpack_public_path__ + "static/icon-instagram-298f1f4437991737880fe628b7da1202.png";